(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sc-mattress-specifications"] && !Shopify.designMode) return;
  try {
    (() => {
  const tag = 'sc-mattress-specifications';
  if (customElements.get(tag)) return;
  const escapePattern = value => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const trim = (text, start, end) => {
    while (start < end && /\s/.test(text[start])) start++;
    while (end > start && /\s/.test(text[end - 1])) end--;
    return [start, end];
  };
  const slice = (unit, start, end) => {
    const walker = document.createTreeWalker(unit, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let offset = 0;
    while (walker.nextNode()) {
      nodes.push({ node: walker.currentNode, start: offset, end: offset + walker.currentNode.length });
      offset += walker.currentNode.length;
    }
    if (start < 0 || end > offset || start >= end) throw new Error('range');
    const first = nodes.find(entry => entry.end > start);
    const last = nodes.find(entry => entry.end >= end);
    const range = document.createRange();
    range.setStart(first.node, start - first.start);
    range.setEnd(last.node, end - last.start);
    let fragment = range.cloneContents();
    let ancestor = range.commonAncestorContainer;
    if (ancestor.nodeType !== Node.ELEMENT_NODE) ancestor = ancestor.parentElement;
    while (ancestor && ancestor !== unit) {
      const shell = ancestor.cloneNode(false);
      shell.append(fragment);
      fragment = shell;
      ancestor = ancestor.parentElement;
    }
    if (fragment.textContent !== unit.textContent.slice(start, end)) throw new Error('text');
    return fragment;
  };
  const units = source => {
    const result = [];
    for (const child of source.childNodes) {
      if (child.nodeType === Node.TEXT_NODE && !child.textContent.trim()) continue;
      if (child.nodeType !== Node.ELEMENT_NODE) throw new Error('root');
      if (child.matches('p')) result.push(child);
      else if (child.matches('ul,ol')) {
        for (const item of child.childNodes) {
          if (item.nodeType === Node.TEXT_NODE && !item.textContent.trim()) continue;
          if (item.nodeType !== Node.ELEMENT_NODE || !item.matches('li')) throw new Error('list');
          result.push(item);
        }
      } else throw new Error('block');
    }
    for (const unit of result) {
      if ([...unit.querySelectorAll('*')].some(node => !node.matches('strong,b,em,i,a,br'))) throw new Error('inline');
    }
    return result;
  };
  const segments = (unit, plan, labels) => {
    const text = unit.textContent;
    if (!text.trim()) return [];
    if (plan.items.every(item => item.kind === 'note') && text.includes('•')) {
      const markers = [...text.matchAll(/•\s*/g)];
      if (text.slice(0, markers[0].index).trim()) throw new Error('features');
      return markers.map((match, index) => ({ kind: 'note', markerStart: match.index, start: match.index + match[0].length, end: markers[index + 1]?.index ?? text.length }));
    }
    if (plan.family === 'copper') {
      const strong = unit.querySelector('strong,b');
      if (strong && labels.includes(strong.textContent)) {
        const label = strong.textContent;
        const pattern = new RegExp('^\\s*(' + escapePattern(label) + ')([\\s]*[—–-][\\s]*)');
        const match = pattern.exec(text);
        if (match) {
          const labelStart = match[0].length - match[1].length - match[2].length;
          return [{ kind: 'pair', label, markerStart: 0, labelStart, labelEnd: labelStart + label.length, valueStart: match[0].length, end: text.length }];
        }
      }
      return [{ kind: 'note', markerStart: 0, start: 0, end: text.length }];
    }
    const boundaries = [];
    if (labels.length) {
      const apparentRows = /(^|[\r\n•])([ \t\u00a0]*)([-•][ \t\u00a0]*)?([^\r\n•:]+?)[ \t\u00a0]*:/g;
      for (const match of text.matchAll(apparentRows)) {
        if (!labels.includes(match[4].trim())) throw new Error('unknown-label');
      }
      const pattern = new RegExp('(^|[\\r\\n•])([ \\t\\u00a0]*)([-•][ \\t\\u00a0]*)?(' + labels.map(escapePattern).join('|') + ')([ \\t\\u00a0]*:[ \\t\\u00a0]*)', 'g');
      for (const match of text.matchAll(pattern)) {
        const labelStart = match.index + match[1].length + match[2].length + (match[3] || '').length;
        boundaries.push({ kind: 'pair', label: match[4], markerStart: match.index, labelStart, labelEnd: labelStart + match[4].length, valueStart: match.index + match[0].length });
      }
    }
    if (plan.groupNotes.includes('Available sizes')) {
      for (const match of text.matchAll(/(^|[\r\n])([ \t]*)(Available sizes)(?=[ \t]*(?:[\r\n]|$))/g)) {
        boundaries.push({ kind: 'note', markerStart: match.index, start: match.index + match[1].length + match[2].length });
      }
    }
    boundaries.sort((a, b) => a.markerStart - b.markerStart);
    if (!boundaries.length) return [{ kind: 'note', markerStart: 0, start: 0, end: text.length }];
    if (text.slice(0, boundaries[0].markerStart).trim()) {
      boundaries.unshift({ kind: 'note', markerStart: 0, start: 0 });
    }
    return boundaries.map((item, index) => ({ ...item, end: boundaries[index + 1]?.markerStart ?? text.length }));
  };
  class MattressSpecifications extends HTMLElement {
    connectedCallback() {
      if (this.dataset.specsState) return;
      const run = () => this.format();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
      else queueMicrotask(run);
    }
    format() {
      if (this.dataset.specsState) return;
      try {
        const plan = JSON.parse(this.dataset.specsPlan);
        if (!Array.isArray(plan.items) || !plan.items.length) throw new Error('plan');
        const source = this.querySelector(':scope > .metafield-rich_text_field');
        if (!source || this.children.length !== 1) throw new Error('source');
        const labels = [...new Set(plan.items.filter(item => item.kind === 'pair').map(item => item.label))].sort((a, b) => b.length - a.length);
        const output = document.createElement('div');
        output.className = 'sc-mattress-specs';
        const found = [];
        for (const unit of units(source)) {
          const text = unit.textContent;
          if (!text.trim()) {
            const spacer = document.createElement('p');
            spacer.className = 'sc-mattress-specs__spacer';
            spacer.append(...[...unit.childNodes].map(node => node.cloneNode(true)));
            output.append(spacer);
            continue;
          }
          const ranges = [];
          for (const item of segments(unit, plan, labels)) {
            if (item.kind === 'pair') {
              const [valueStart, valueEnd] = trim(text, item.valueStart, item.end);
              if (valueStart === valueEnd) throw new Error('empty');
              const row = document.createElement('dl');
              row.className = 'sc-mattress-specs__row';
              const term = document.createElement('dt');
              const value = document.createElement('dd');
              term.append(slice(unit, item.labelStart, item.labelEnd));
              value.append(slice(unit, valueStart, valueEnd));
              row.append(term, value);
              output.append(row);
              ranges.push([item.labelStart, item.labelEnd], [valueStart, valueEnd]);
              found.push({ kind: 'pair', label: term.textContent });
            } else {
              const [start, end] = trim(text, item.start, item.end);
              if (start === end) continue;
              const note = document.createElement('p');
              note.className = 'sc-mattress-specs__note';
              note.append(slice(unit, start, end));
              output.append(note);
              ranges.push([start, end]);
              found.push({ kind: 'note' });
            }
          }
          ranges.sort((a, b) => a[0] - b[0]);
          let position = 0;
          for (const [start, end] of ranges) {
            if (start < position || !/^[\s•:—–-]*$/.test(text.slice(position, start))) throw new Error('coverage');
            position = end;
          }
          if (!/^[\s•:—–-]*$/.test(text.slice(position))) throw new Error('coverage');
        }
        if (JSON.stringify(found) !== JSON.stringify(plan.items)) throw new Error('shape');
        this.replaceChildren(output);
        this.dataset.specsState = 'formatted';
      } catch (error) {
        this.dataset.specsState = 'fallback';
        this.dataset.specsReason = error.message;
      }
    }
  }
  customElements.define(tag, MattressSpecifications);
})();
  } catch(e) { console.error(e); }
})();

})();
